import * as React from "react";
import { SVGProps } from "react";
const SvgCurrencyEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.35 22.372c1.206 0 2.232-.27 3.097-.702l-.63-2.304a4.767 4.767 0 0 1-2.322.63c-1.027 0-1.783-.702-2.161-1.836h2.773l.52-1.602h-3.545c-.017-.162-.017-.324-.017-.504v-.324h3.798l.54-1.602h-4.195c.252-1.188.81-1.926 2.07-1.926.955 0 1.818.27 2.467.54l.809-2.232c-1.044-.432-1.926-.684-3.204-.684-3.042 0-4.481 1.656-4.914 4.302h-.99v1.602h.829v.828h-.828v1.602h1.007c.522 2.772 2.197 4.212 4.896 4.212Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCurrencyEuro;
